import cn from 'classnames'
import React, { useContext } from 'react'

//
import { IconNew } from '..'
import { SiteDataContext } from '../../components/page-wrapper'
import { getMicroCopy } from '../../utils/microcopy'
import FooterMenu from '../FooterMenu'
import Logo from '../Logo'

const Footer = ({
  minified = false,
  footerMenus = {},
  languageCountryMenu = {},
  socialMenu = {},
  footerText = {},
  legalMenu = {},
  language = '',
  country = '',
  microCopyData = {},
  handleSelectLanguage = () => null,
  handleSelectCountry = () => null
}) => {
  const { isTextRtl } = useContext(SiteDataContext)

  const rootClasses = cn('c-footer', {
    'c-footer--minified': minified,
    'c-footer--rtl': isTextRtl
  })

  const renderSocials = (socialMenu) =>
    socialMenu.items.map((item) => {
      const socialIcon = `${item.label.toLowerCase()}`

      return (
        <a
          key={item.id}
          className="c-footer__social-link"
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          title={item.label}
        >
          <IconNew social={true} name={socialIcon} size={24} />
        </a>
      )
    })

  const renderLanguageLocation = () => {
    return (
      <div className="c-footer__market-switcher">
        <div className="c-footer__select-group">
          <IconNew name={'tabler-language'} size={16} />
          <select
            aria-label="Language"
            value={language}
            name="language-selector"
            onChange={(e) => handleSelectLanguage(e.target.value)}
          >
            <optgroup
              label={getMicroCopy({
                key: 'language',
                fallback: 'Language',
                data: microCopyData
              })}
            >
              {languageCountryMenu?.languageItems.map((language) => {
                return (
                  <option key={language.id} value={language.value}>
                    {language.label}
                  </option>
                )
              })}
            </optgroup>
          </select>
          <IconNew style={{ pointerEvents: 'none' }} name={'tabler-chevron-down'} size={16} />
        </div>

        <div className="c-footer__select-group">
          <IconNew name={'tabler-world'} size={16} />
          <select
            aria-label="Market"
            value={country}
            name="country-selector"
            onChange={(e) => handleSelectCountry(e.target.value)}
          >
            <optgroup
              label={getMicroCopy({
                key: 'country',
                fallback: 'Country',
                data: microCopyData
              })}
            >
              {languageCountryMenu?.countryItems.map((language) => {
                return (
                  <option key={language.id} value={language.value}>
                    {language.label}
                  </option>
                )
              })}
            </optgroup>
          </select>
          <IconNew style={{ pointerEvents: 'none' }} name={'tabler-chevron-down'} size={16} />
        </div>
      </div>
    )
  }

  if (minified) {
    return (
      <footer className={rootClasses}>
        <div className="c-footer__container l-container:12/12 l-container--default-spacing">
          <div className="c-footer__brand">
            <Logo classes="c-footer__logo" variant="white" width={265} size={48} withText />
            <div className="c-footer__social">{renderSocials(socialMenu)}</div>
            <div className="c-footer__copyright">
              <p>{footerText.copyright}</p>
              <p>{footerText.companyInfo}</p>
            </div>
            {legalMenu.items && (
              <ul className="c-footer__legal">
                {legalMenu.items.map((item) => (
                  <li key={item.id} className="c-footer__legal-menu-item">
                    <a className="c-footer__legal-menu-link" href={item.url} title={item.label}>
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </footer>
    )
  }

  return (
    <footer className={rootClasses}>
      <div className="c-footer__wrapper l-container:12/12">
        <div className="c-footer__container">
          <div className="c-footer__brand">
            <Logo classes="c-footer__logo" variant="white" width={265} size={48} withText />
            <div className="c-footer__social">{renderSocials(socialMenu)}</div>
            {renderLanguageLocation()}
            <div className="c-footer__copyright">
              <p>{footerText.copyright}</p>
              <p>{footerText.companyInfo}</p>
            </div>
          </div>
          <nav className="c-footer__navigation">
            {footerMenus &&
              footerMenus.map((col) => (
                <div className="c-footer__navigation-wrapper" key={col.id}>
                  {col.menus &&
                    col.menus.map((menu) => (
                      <FooterMenu title={menu.title} items={menu.items} key={menu.id} />
                    ))}
                </div>
              ))}
          </nav>
        </div>
        {legalMenu.items && (
          <ul className="c-footer__legal">
            {legalMenu.items.map((item) => (
              <li key={item.id} className="c-footer__legal-menu-item">
                <a className="c-footer__legal-menu-link" href={item.url} title={item.label}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </footer>
  )
}

export default Footer
